import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { Ionicons as Icon } from '@expo/vector-icons';
import { Colors } from '../constants/colors';
import HomeScreen from '../screens/HomeScreen';
import QuestsScreen from '../screens/QuestsScreen';
import GoalsScreen from '../screens/GoalsScreen';
import ConnectScreen from '../screens/ConnectScreen';
import SettingsScreen from '../screens/SettingsScreen';

const Tab = createBottomTabNavigator();

function TabIcon({ name, focused }) {
  const iconMap = {
    Home: focused ? 'home' : 'home-outline',
    Quests: focused ? 'grid' : 'grid-outline',
    Goals: focused ? 'flame' : 'flame-outline',
    Connect: focused ? 'chatbubbles' : 'chatbubbles-outline',
    Me: focused ? 'person' : 'person-outline',
  };
  const color = focused ? Colors.accent : 'rgba(255,255,255,0.7)';
  return (
    <View style={styles.tabIconContainer}>
      <Icon name={iconMap[name]} size={22} color={color} />
      {focused && <View style={styles.activeIndicator} />}
    </View>
  );
}

export default function MainTabNavigator() {
  return (
    <Tab.Navigator
      screenOptions={{
        headerShown: false,
        tabBarStyle: styles.tabBar,
        tabBarActiveTintColor: Colors.accent,
        tabBarInactiveTintColor: 'rgba(255,255,255,0.7)',
        tabBarLabelStyle: styles.tabLabel,
      }}
    >
      <Tab.Screen
        name="Home"
        component={HomeScreen}
        options={{ tabBarIcon: ({ focused }) => <TabIcon name="Home" focused={focused} /> }}
      />
      <Tab.Screen
        name="Quests"
        component={QuestsScreen}
        options={{ tabBarIcon: ({ focused }) => <TabIcon name="Quests" focused={focused} /> }}
      />
      <Tab.Screen
        name="Goals"
        component={GoalsScreen}
        options={{ tabBarIcon: ({ focused }) => <TabIcon name="Goals" focused={focused} /> }}
      />
      <Tab.Screen
        name="Connect"
        component={ConnectScreen}
        options={{ tabBarIcon: ({ focused }) => <TabIcon name="Connect" focused={focused} /> }}
      />
      <Tab.Screen
        name="Me"
        component={SettingsScreen}
        options={{ tabBarIcon: ({ focused }) => <TabIcon name="Me" focused={focused} /> }}
      />
    </Tab.Navigator>
  );
}

const styles = StyleSheet.create({
  tabBar: {
    backgroundColor: Colors.navBar,
    borderTopWidth: 0,
    height: 85,
    paddingTop: 8,
    paddingBottom: 28,
    elevation: 0,
    shadowOpacity: 0,
  },
  tabLabel: {
    fontSize: 10,
    fontWeight: '600',
    marginTop: 2,
  },
  tabIconContainer: {
    alignItems: 'center',
  },
  activeIndicator: {
    width: 24,
    height: 2.5,
    backgroundColor: Colors.accent,
    borderRadius: 2,
    marginTop: 4,
  },
});
